<template>
  <esg-base-dashboard>
    <b-container fluid
                 class="px-0">
      <b-row>
        <b-col>
          <esg-base-dashboard-card title="목표대비 온실가스 배출량">
            <template #actions>
              <esg-base-select-box label="목표"
                                   :options="chartOptions"
                                   v-model="chartOption"/>
            </template>
            <sbti-monitoring v-if="chartOption === 'SBTi'"/>
            <ndc-monitoring v-if="chartOption === 'NDC'"/>
            <ipcc-monitoring v-if="chartOption === 'IPCC'"/>
          </esg-base-dashboard-card>
        </b-col>
      </b-row>
    </b-container>
  </esg-base-dashboard>
</template>
<script>
import EsgBaseDashboard from "@/components/esg/base/EsgBaseDashboard.vue";
import EsgBaseDashboardCard from "@/components/esg/base/EsgBaseDashboardCard.vue";
import SbtiMonitoring from "../../dashboardCards/TargetSBTiMonitoring.vue";
import NdcMonitoring from "../../dashboardCards/TargetNdcMonitoring.vue";
import IpccMonitoring from "../../dashboardCards/TargetIpccMonitoring.vue";
import EsgBaseSelectBox from "@/components/esg/base/form/EsgBaseSelectBox.vue";

export default {
  components: {
    EsgBaseSelectBox,
    IpccMonitoring,
    NdcMonitoring,
    EsgBaseDashboard,
    EsgBaseDashboardCard,
    SbtiMonitoring
  },
  data() {
    return {
      data: [],
      chartOption: 'SBTi',
      chartOptions: [
        { text: 'SBTi', value: 'SBTi' },
        { text: 'NDC', value: 'NDC' },
        { text: 'IPCC 1.5°C', value: 'IPCC' }
      ],
    }
  },
}
</script>

<style scoped>
>>> .card .card-body {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>